import React, { JSX, useState } from "react";
import { Switch, Table, TableColumnsType, Tag } from "antd";
import { useQuery } from "react-query";
import Text from "../../components/Text/Text";
import color from "../../resource/color";
import { ShopTierCompanyConfig } from "./config";
import { ConfigYear } from "./mockData";
import { AlignTopTableContainer } from "./styled";
import { useNavigate } from "react-router";
import { CopyOutlined, DeleteOutlined, UnorderedListOutlined } from "@ant-design/icons";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import { getTierProgramSettingList } from "../../datasource/TierProgramDatasource";
import dayjs from "dayjs";

interface TierProgramSetting {
  year: number | string;
  yearOffset: number;
  status: "active" | "upcoming" | "closed" | string;
  tierCount: number;
  updatedAt: string;
  updatedBy: string;
  tierProgramId : string;
}

function yearDescription(yearOffset: number): string {
  if (yearOffset === 0) return "ปีปัจจุบัน";
  if (yearOffset > 0) return "ปีถัดไป";
  return "ปีก่อนหน้า";
}

interface Props {
  config: ShopTierCompanyConfig;
  configYears: ConfigYear[];
}
const datePattern = "DD/MM/YYYY";

function ConfigTab({ configYears }: Props): JSX.Element {
  const navigate = useNavigate();
  const [check, setCheck] = useState(false);
  const [showDuplicateConfirm, setShowDuplicateConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [year, setYear] = useState<string | null>(null);

  const company = JSON.parse(localStorage.getItem("profile") || "null")?.company;

  const { data: tierProgramList, isLoading } = useQuery(
    ["tier-program-setting-list", company],
    () => getTierProgramSettingList({ company }),
    { enabled: !!company, refetchOnWindowFocus: false },
  );
  console.log(tierProgramList?.responseData);

  const dataSource: TierProgramSetting[] = tierProgramList?.responseData ?? [];

  const yearColumns: TableColumnsType<TierProgramSetting> = [
    {
      title: "ปีสิทธิประโยชน์",
      dataIndex: "year",
      key: "year",
      render: (year: number | string, record) => (
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Text fontFamily="Sarabun" fontSize={16} fontWeight={700} color="Text2">{`ปี ${year}`}</Text>
          <Text fontFamily="Sarabun" fontSize={12} fontWeight={500} color="Text3">{yearDescription(record.yearOffset)}</Text>
        </div>
      ),
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (status: TierProgramSetting["status"]) =>
        status === "PUBLISHED" ? (
          <Tag style={{ borderRadius: "16px" }} color={color.success}>
            <Text fontSize={14} fontWeight={700} color="white">
              ร้านใช้สิทธิ์ชุดนี้อยู่
            </Text>
          </Tag>
        ) : (
          <Tag style={{ borderRadius: "16px" }} color={color.Grey}>
            <Text fontSize={14} fontWeight={700} color="white">
              {status === "upcoming" ? "เตรียมไว้ ร้านยังไม่เห็น" : "จบรอบแล้ว"}
            </Text>
          </Tag>
        ),
    },
    {
      title: "ระดับทั้งหมด",
      dataIndex: "tierCount",
      key: "tierCount",
      render: (count: number) => (
        <Text fontFamily="Sarabun" fontSize={16} fontWeight={400} color="Text2">{count} ระดับ</Text>
      ),
    },
    {
      title: "แก้ไขล่าสุด",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (date: string, record) => (
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Text fontFamily="Sarabun" fontSize={16} fontWeight={400} color="Text2">{dayjs(date).format(datePattern)}</Text>
          <Text fontFamily="Sarabun" fontSize={12} fontWeight={500} color="Text3">{record.updatedBy}</Text>
        </div>
      ),
    },
  ];

  return (
    <div>
      {/* <div style={{
        margin: "20px 0px 16px",
        padding: "8px 12px",
        borderRadius: 6,
        background: color.background1,
        fontFamily: "Sarabun",
        fontSize: 13,
        lineHeight: "20px",
        color: color.Text3,
      }}>
        ระดับที่ร้านถืออยู่ในแต่ละปีมาจากผลงานของปีก่อนหน้า ชุดสิทธิ์ปี 2569 จึงเป็นของระดับที่ร้านทำได้ในปี 2568 ส่วนผลงานปี 2569 จะไปให้สิทธิ์ของปี 2570
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: color.background1,
          borderRadius: 8,
          padding: "12px 16px",
          marginBottom: 16,
        }}
      >
        <div>
          <Text fontWeight={700}>แสดงสิทธิประโยชน์ปีหน้าในแอปร้านค้า</Text>
          <div>
            <Text fontSize={12} color="Text3">
              ระดับบริษัท มีผลทุกระดับ ทุกการเปลี่ยนแปลงบันทึกลง Audit Log
            </Text>
          </div>
        </div>
        <Switch checked={check} onChange={(v) => setCheck(v)} />
      </div> */}

      <AlignTopTableContainer>
        <Table rowKey="year" dataSource={dataSource} loading={isLoading} columns={yearColumns} pagination={false} onRow={(record) => ({
            style: { cursor: "pointer" },
            onClick: () => navigate(`/ShopTier/benefit/${record.tierProgramId}`),
          })}/>
      </AlignTopTableContainer>
      <ConfirmModal
        visible={showDuplicateConfirm}
        title="ยืนยันการทำสำเนา"
        desc={`สร้างสำเนาสิทธิประโยชน์${year} เป็นปีใหม่ ระบบจะคัดลอกเกณฑ์และสิทธิประโยชน์ทั้งหมดของปีนี้ไปยังปีที่สร้างใหม่`}
        onConfirm={() => {
          setShowDuplicateConfirm(false);
        }}
        onCancel={() => setShowDuplicateConfirm(false)}
      />

      <ConfirmModal
        visible={showDeleteConfirm}
        title="ยืนยันการลบสิทธิประโยชน์"
        desc={`ลบสิทธิประโยชน์${year} ออกจากระบบถาวร ร้านค้าจะไม่เห็นสิทธิประโยชน์นี้อีก และไม่สามารถกู้คืนได้`}
        confirmText="ลบ"
        typeButtonSubmit="danger"
        onConfirm={() => {
          setShowDeleteConfirm(false);
        }}
        onCancel={() => setShowDeleteConfirm(false)}
      />
    </div>
  );
}

export default ConfigTab;
